"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QcItemStatus = void 0;
var QcItemStatus;
(function (QcItemStatus) {
    QcItemStatus["INSPECTION_REJECTED"] = "INSPECTION_REJECTED";
    QcItemStatus["INSPECTION_APPROVED"] = "INSPECTION_APPROVED";
    QcItemStatus["LOST_DURING_INSPECTION"] = "LOST_DURING_INSPECTION";
    QcItemStatus["LOST_BY_CARRIER"] = "LOST_BY_CARRIER";
    QcItemStatus["DONATED"] = "DONATED";
    QcItemStatus["DESTROYED"] = "DESTROYED";
    QcItemStatus["NOT_RECEIVED"] = "NOT_RECEIVED";
    QcItemStatus["RETURN_TO_SELLER"] = "RETURN_TO_SELLER";
    QcItemStatus["LIQUIDATED"] = "LIQUIDATED";
    QcItemStatus["DISPOSED"] = "DISPOSED";
})(QcItemStatus || (exports.QcItemStatus = QcItemStatus = {}));
//# sourceMappingURL=QcItemStatus.js.map